import { apiService } from './api';
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

if (!API_BASE_URL) {
  console.error("❌ NEXT_PUBLIC_API_BASE_URL is not defined in .env");
}

export const authService = {
  // Connexion - VERSION CORRIGÉE
  async login(credentials) {
    try {
      console.log('🔄 Tentative de connexion...', credentials.username);
      
      // Utilise fetch directement pour debugger
      const response = await fetch(API_BASE_URL +'/auth/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(credentials),
      });

      console.log('📡 Statut réponse:', response.status);
      
      const data = await response.json();
      console.log('📦 Données reçues:', data);

      if (!response.ok) {
        throw new Error(data.message || `Erreur ${response.status}`);
      }

      if (data.success && data.token && data.user) {
        localStorage.setItem('authToken', data.token);
        localStorage.setItem('user', JSON.stringify(data.user));
        console.log('✅ Connexion réussie, user:', data.user);
        return data;
      } else {
        throw new Error(data.message || 'Réponse de connexion invalide');
      }
      
    } catch (error) {
      console.error('❌ Erreur connexion:', error);
      localStorage.removeItem('authToken');
      localStorage.removeItem('user');
      throw error;
    }
  },

  // Déconnexion
  logout() {
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
    window.location.href = '/login';
  },

  // Vérifier si l'utilisateur est connecté
  isAuthenticated() {
    const token = localStorage.getItem('authToken');
    return !!token;
  },

  // Récupérer le token
  getToken() {
    return localStorage.getItem('authToken');
  },

  // Récupérer l'utilisateur
  getCurrentUser() {
    const userStr = localStorage.getItem('user');
    try {
      return userStr ? JSON.parse(userStr) : null;
    } catch (e) {
      console.error('Erreur parsing user:', e);
      return null;
    }
  },

  // Rafraîchir les infos utilisateur
  async refreshUser() {
    try {
      const response = await apiService.get('/users/me');
      if (response.data) {
        localStorage.setItem('user', JSON.stringify(response.data));
        return response.data;
      }
    } catch (error) {
      console.error('Erreur rafraîchissement utilisateur:', error);
      this.logout();
    }
  }
};